<script setup lang="ts">
import { useBannersStore } from '@/store/banners/banners'

// Components
import MainBannerSlide from '@/components/Main/MainBannerSlide.vue'

const { isDesktop } = useDevice()

const bannersStore = useBannersStore()

// Рассчет отображения слайдов
const sliderPerView = computed(() => (isDesktop ? 3 : 1))

const sliders = computed(() =>
  isDesktop && bannersStore.data.banners.length > 3
    ? bannersStore.data.banners.concat(bannersStore.data.banners)
    : bannersStore.data.banners,
)

// Определяем навигацию
const isVisibleNavigation = computed(
  () => isDesktop && sliders.value.length > 3,
)

// Определение loop эффекта
const isLoopSlieders = computed(
  () => (isDesktop && sliders.value.length > 6) || !isDesktop,
)
</script>

<template>
  <div>
    <Swiper
      class="banner-swiper"
      :modules="[SwiperAutoplay, SwiperNavigation]"
      :slides-per-view="sliderPerView"
      :loop="isLoopSlieders"
      :touch="true"
      :navigation="isVisibleNavigation"
      :space-between="8"
    >
      <SwiperSlide
        v-for="(slide, index) in sliders"
        :key="index"
        class="banner-swiper__slide"
      >
        <main-banner-slide
          :slide="slide"
          class="banner-swiper__slide-content"
        />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<style lang="scss">
:root {
  // Переназначаем var params swipper
  --swiper-navigation-size: 16px;
  --swiper-theme-color: $text-black;
}

.swiper-button-prev,
.swiper-button-next {
  top: 0;
  width: 40px;
  height: 100%;
  margin: 0;
}

.swiper-button-prev {
  left: 10px;
}
.swiper-button-next {
  right: 10px;
}
.swiper-button-prev::after,
.swiper-button-next::after {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  font-weight: 900;
  background-color: $background-milk;
  border-radius: 50%;
  box-shadow: 0 4px 20px rgba(65, 58, 91, 0.15);
}
</style>

<style lang="scss" scoped>
.banner-swiper {
  @include media('<=desktop-mini') {
    padding: 0 24px;
    overflow-y: hidden;
  }
  @include media('<=tablet') {
    padding: 0;
  }
  &__slide-content {
    @include media('<desktop-mini') {
      width: 100%;
    }
  }
}
.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  border-radius: 20px;

  @include media('<desktop-mini') {
    height: 100% !important;
  }
}
.swiper-wrapper {
  width: 100%;
  min-width: 100%;
}
</style>
